(function(){
  function esc(v){ return String(v==null?'':v).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function fill(t,v){ return String(t||'').replace(/\{(\w+)\}/g,function(m,k){ return v[k]!==undefined ? v[k] : ''; }); }

  /* Il nome si scrive come capita: tutto minuscolo, tutto maiuscolo, con lo
     spazio di troppo. Lo rimettiamo in ordine prima di stamparlo in mezzo a una
     frase, altrimenti "ecco da dove viene, GIULIA" urla addosso alla cliente.
     Si tengono i nomi composti (Maria Chiara) e gli apostrofi (Sant'Elena). */
  function pulisciNome(v){
    var n = String(v||'').replace(/\s+/g,' ').trim().slice(0,24);
    if (!n) return '';
    return n.split(' ').map(function(p){
      return p.split('-').map(function(q){
        return q ? q.charAt(0).toUpperCase() + q.slice(1).toLowerCase() : q;
      }).join('-');
    }).join(' ');
  }
  function nomeValido(n){
    return n.length >= 2 && !/[0-9@<>\/\\]/.test(n);
  }

  function init(root){
    (root||document).querySelectorAll('[data-km-quiz]:not([data-km-ready])').forEach(function(el){
      el.setAttribute('data-km-ready','1');
      var cfg={}; try{ cfg=JSON.parse(el.getAttribute('data-km-quiz')||'{}'); }catch(e){}
      var extra=null; if(cfg.db){ try{ var o=JSON.parse(cfg.db); if(o&&Object.keys(o).length) extra=o; }catch(e){} }

      var steps = Array.prototype.slice.call(el.querySelectorAll('[data-km-step]'));
      var bar   = el.querySelector('[data-km-bar]');
      var count = el.querySelector('[data-km-count]');
      var out   = el.querySelector('[data-km-out]');
      var hint  = el.querySelector('[data-km-hint]');
      var hnome = el.querySelector('[data-km-hint-nome]');
      var shint = el.querySelector('[data-km-stephint]');
      var next  = el.querySelector('[data-km-next]');
      var prev  = el.querySelector('[data-km-prev]');
      var nav   = el.querySelector('[data-km-nav]');
      var i = 0;

      function show(n){
        i = n;
        steps.forEach(function(s,k){ s.hidden = (k !== n); });
        if (bar) bar.style.width = ((n+1)/steps.length*100).toFixed(0) + '%';
        if (count) count.textContent = (n+1) + ' / ' + steps.length;
        if (hint) hint.hidden = true;
        if (hnome) hnome.hidden = true;
        if (shint) shint.hidden = true;
        var ultimo = (n === steps.length - 1);
        if (next) next.hidden = ultimo;
        if (prev) prev.hidden = (n === 0);
        if (nav) nav.hidden = (ultimo && n === 0);
      }

      function passoValido(){
        var st = steps[i];
        if (!st) return true;
        if (st.querySelector('[data-km-cap]')) return true;
        return !!st.querySelector('[data-km-opt][aria-pressed="true"]');
      }

      el.addEventListener('click', function(e){
        var opt = e.target.closest('[data-km-opt]');
        if (opt) {
          if (opt.closest('[data-km-step]').getAttribute('data-km-single') === 'true') {
            opt.closest('[data-km-opts]').querySelectorAll('[data-km-opt]').forEach(function(o){ o.setAttribute('aria-pressed','false'); });
          }
          opt.setAttribute('aria-pressed', opt.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          if (shint) shint.hidden = true;
          return;
        }
        if (e.target.closest('[data-km-next]')) {
          if (!passoValido()) {
            if (shint) { shint.textContent = cfg.hint_step || 'Seleziona almeno un’opzione per continuare.'; shint.hidden = false; }
            return;
          }
          if (i < steps.length-1) show(i+1);
          return;
        }
        if (e.target.closest('[data-km-prev]')) { if (i > 0) show(i-1); return; }
      });

      var form = el.querySelector('[data-km-form]');
      var cap  = el.querySelector('[data-km-cap]');
      var nome = el.querySelector('[data-km-nome]');
      if (cap) cap.addEventListener('input', function(){ cap.value = cap.value.replace(/[^0-9]/g,'').slice(0,5); if(hint) hint.hidden=true; });
      if (nome) nome.addEventListener('input', function(){ if(hnome) hnome.hidden = true; });

      form.addEventListener('submit', function(e){
        e.preventDefault();

        /* Il nome si controlla per primo: e' il campo piu' in alto, e mandare la
           cliente a sistemare il CAP mentre il nome e' vuoto la fa scendere e
           risalire per niente. */
        var chiSei = pulisciNome(nome ? nome.value : '');
        if (nome && !nomeValido(chiSei)) {
          if (hnome) { hnome.textContent = cfg.hint_nome || 'Scrivi il tuo nome per vedere il risultato.'; hnome.hidden = false; }
          nome.focus(); return;
        }
        if (hnome) hnome.hidden = true;
        if (nome && chiSei) nome.value = chiSei;

        var c = (cap.value||'').trim();
        var acqua = window.KM_LOOKUP ? window.KM_LOOKUP.cerca(c, extra) : null;
        if (!acqua) {
          if (hint) {
            hint.textContent = /^[0-9]{5}$/.test(c) ? (cfg.hint_sconosciuto || cfg.hint) : cfg.hint;
            hint.hidden = false;
          }
          cap.focus(); return;
        }
        if (hint) hint.hidden = true;

        var sel = Array.prototype.slice.call(el.querySelectorAll('[data-km-opt][aria-pressed="true"]'));
        var cause = { calcare:0, cloro:0, metalli:0 };
        var etichette = [];
        sel.forEach(function(o){
          var cz = o.getAttribute('data-causa');
          if (cause[cz] !== undefined) cause[cz]++;
          var l = o.getAttribute('data-label'); if (l) etichette.push(l);
        });

        var mgl = acqua.mgl, luogo = acqua.luogo;
        var L = Number(cfg.litri)||54;
        var grammi = Math.round(mgl*L/1000);
        var gf = Math.round(mgl/10);
        var t1=Number(cfg.t_dolce)||150, t2=Number(cfg.t_media)||250, t3=Number(cfg.t_dura)||350;
        var k = mgl<=t1 ? 'dolce' : mgl<=t2 ? 'media' : mgl<=t3 ? 'dura' : 'molto';
        var nomi = { dolce:cfg.n_dolce, media:cfg.n_media, dura:cfg.n_dura, molto:cfg.n_molto };
        var colori= { dolce:cfg.c_dolce, media:cfg.c_media, dura:cfg.c_dura, molto:cfg.c_molto };
        var acquaDura = (k === 'dura' || k === 'molto');

        var scen;
        if (cause.calcare + cause.metalli > 0 && acquaDura) scen = 'conferma';
        else if (cause.calcare + cause.metalli > 0 && cause.cloro > 0) scen = 'cloro';
        else if (cause.calcare + cause.metalli > 0) scen = 'nondura';
        else if (cause.cloro > 0) scen = 'cloro';
        else scen = 'nessuno';

        var mesi = (k==='molto') ? 2 : (k==='dura') ? 3 : (k==='media') ? 5 : 8;

        /* Quanto dura UN filtro, che e' quello che c'e' nella scatola. Numeri
           prudenti e allineati a quello che il sito dichiara ovunque ("da due a
           quattro mesi"): il calcare non perdona e una stima gonfiata si paga in
           assistenza. Non e' la stessa cosa di "mesi", che dice invece fra quanto
           si sente il velo se oggi non si sente. */
        var mesiFiltri = (k==='molto') ? 2 : (k==='dura') ? 3 : (k==='media') ? 4 : 4;

        var classe = nomi[k] || '';
        var vars = {
          nome: chiSei, luogo: luogo, cap: c, mgl: mgl, grammi: grammi, gradi: gf,
          classe: classe, acqua: classe.replace(/^acqua\s+/i,'').toLowerCase(),
          mesi: mesi, filtri: mesiFiltri
        };
        var nota = acqua.precisione === 'provincia' ? (cfg.nota_provincia || '') : '';

        var chips = etichette.length
          ? '<div class="km-q__chips">' + etichette.map(function(l){
              return '<span class="km-q__chip" style="background:'+esc(cfg.bruma)+';color:'+esc(cfg.blu)+'">'+esc(l)+'</span>';
            }).join('') + '</div>'
          : '';

        /* La proposta d'acquisto sotto il verdetto. Il prodotto e la confezione
           li sceglie Luca dall'editor: qui arrivano gia' risolti dentro cfg, con
           l'id della variante. Il pulsante non ha una sua logica, usa
           data-km-up-add di km-cart.js, lo stesso del carrello: una strada sola
           per aggiungere roba al carrello, gia' collaudata. */
        var upsell = '';
        if (cfg.up_on && cfg.up_id) {
          upsell =
            '<div class="km-q__up" data-km-upsell style="border-color:'+esc(cfg.bruma)+'">' +
              (cfg.up_img ? '<div class="km-q__up-foto"><img src="'+esc(cfg.up_img)+'" alt="'+esc(cfg.up_nome)+'" width="160" height="160" loading="lazy"></div>' : '') +
              '<div class="km-q__up-b">' +
                (cfg.up_titolo ? '<p class="km-q__up-t" style="color:'+esc(cfg.blu)+'">'+esc(fill(cfg.up_titolo, vars))+'</p>' : '') +
                (cfg.up_testo ? '<p class="km-q__up-x">'+esc(fill(cfg.up_testo, vars))+'</p>' : '') +
                '<p class="km-q__up-p" style="color:'+esc(cfg.blu)+'">' +
                  '<span>'+esc(cfg.up_nome)+(cfg.up_var ? ' · '+esc(cfg.up_var) : '')+'</span>' +
                  '<strong>'+esc(cfg.up_prezzo)+'</strong>' +
                  (cfg.up_barrato ? '<s>'+esc(cfg.up_barrato)+'</s>' : '') +
                '</p>' +
                '<div class="km-q__up-az">' +
                  '<button type="button" class="km__btn" data-km-up-add data-id="'+esc(cfg.up_id)+'" style="background:'+esc(cfg.accent)+';color:'+esc(cfg.blu_ink)+'">'+esc(fill(cfg.up_btn, vars))+'</button>' +
                  (cfg.up_url ? '<a class="km-q__up-link" href="'+esc(cfg.up_url)+'">'+esc(cfg.up_link || 'Vedi la scheda')+'</a>' : '') +
                '</div>' +
                (cfg.up_nota ? '<p class="km-q__up-n">'+esc(fill(cfg.up_nota, vars))+'</p>' : '') +
                '<div class="km-up__err" data-km-up-err hidden></div>' +
              '</div>' +
            '</div>';
        }

        out.innerHTML =
          '<div class="km-q__res">' +
            '<div class="km-at__kicker" style="color:'+esc(cfg.accent)+'">'+esc(fill(cfg.label_res, vars))+'</div>' +
            '<h3 class="km-q__titolo" style="color:'+esc(cfg.blu)+'">'+esc(fill(cfg['t_'+scen], vars))+'</h3>' +
            (cfg.saluto ? '<p class="km-q__ciao">'+esc(fill(cfg.saluto, vars))+'</p>' : '') +
            chips +
            '<div class="km-at__grid" style="margin-top:26px">' +
              '<div><p class="km-at__verdetto">'+esc(fill(cfg['v_'+scen], vars))+'</p></div>' +
              '<div class="km-at__box" style="background:'+esc(cfg.bruma)+'">' +
                '<div class="km-at__kicker" style="color:'+esc(cfg.blu)+';margin-bottom:14px">'+esc(luogo)+' · '+esc(c)+'</div>' +
                '<div class="km-q__pill" style="background:'+esc(colori[k])+'">'+esc(nomi[k])+'</div>' +
                '<div class="km-at__nums" style="margin-top:18px">' +
                  '<div><div class="km-at__n" style="color:'+esc(cfg.blu)+'">'+mgl+'</div><div class="km-at__nl">'+esc(cfg.label_mgl)+'</div></div>' +
                  '<div><div class="km-at__n" style="color:'+esc(cfg.blu)+'">'+grammi+'</div><div class="km-at__nl">'+esc(cfg.label_grammi)+'</div></div>' +
                '</div>' +
                '<div class="km-at__nota">'+gf+' '+esc(cfg.label_gradi)+(nota ? ' · '+esc(nota) : '')+'</div>' +
              '</div>' +
            '</div>' +
            '<div class="km-at__cta" style="background:'+esc(cfg.blu)+'">' +
              '<div>' +
                '<div class="km-at__kicker" style="color:'+esc(cfg.accent)+'">'+esc(fill(cfg.label_cta, vars))+'</div>' +
                '<div class="km-at__utile">'+esc(fill(cfg['u_'+scen], vars))+'</div>' +
                '<div class="km-at__filtri">'+esc(fill(cfg['f_'+k], vars))+'</div>' +
              '</div>' +
              (cfg.cta_link ? '<a class="km__btn" href="'+esc(cfg.cta_link)+'" style="background:'+esc(cfg.accent)+';color:'+esc(cfg.blu_ink)+'">'+esc(fill(cfg.cta_label, vars))+'</a>' : '') +
            '</div>' +
            upsell +
          '</div>';

        steps.forEach(function(s){ s.hidden = true; });
        if (nav) nav.hidden = true;
        if (bar) bar.style.width = '100%';
        if (count) count.textContent = cfg.label_fine || 'Fatto';

        document.documentElement.classList.add('km-quiz-fatto');
        try {
          sessionStorage.setItem('kmQuizFatto','1');
          sessionStorage.setItem('kmMesiFiltri', String(mesiFiltri));
          sessionStorage.setItem('kmMesi', String(mesi));
          sessionStorage.setItem('kmAcquaNome', classe);
          sessionStorage.setItem('kmNome', chiSei);
          sessionStorage.setItem('kmLuogo', luogo || '');
          sessionStorage.setItem('kmCap', c);
        } catch(err){}

        /* Il quiz puo' vivere dentro la scheda prodotto. Chi e' in ascolto si
           aggiorna subito, senza ricaricare la pagina: e' il caso della riga
           della durata nelle schede confezione, che da forbice generica diventa
           i mesi calcolati sul CAP di chi sta guardando, e delle righe col nome
           tenute da km-tu.js.

           Prima questo evento non c'era: il risultato finiva solo in
           sessionStorage e la scheda lo leggeva al caricamento successivo. Con
           il quiz sulla stessa pagina quel giro non avviene mai. */
        try {
          document.dispatchEvent(new CustomEvent('km:quiz', { detail: {
            nome: chiSei,
            mesiFiltri: mesiFiltri,
            acqua: nomi[k] || '',
            classe: k,
            mgl: mgl,
            grammi: grammi,
            gradi: gf,
            luogo: luogo,
            cap: c,
            scenario: scen
          }}));
        } catch(err){}

        try { out.scrollIntoView({behavior:'smooth', block:'nearest'}); } catch(e){}
      });

      show(0);
    });
  }

  /* Quando il quiz sta nella stessa pagina del prodotto, il pulsante del verdetto
     non deve portare via: riporta alla scheda d'acquisto in cima. Si aggancia una
     volta sola, per delega, e non fa niente se un vero #acquisto non esiste. */
  if(!window.__kmQuizSu){
    window.__kmQuizSu = true;
    document.addEventListener('click', function(e){
      if(!e.target.closest) return;
      var a = e.target.closest('a[href="#acquisto"]');
      if(!a) return;
      var meta = document.getElementById('acquisto') || document.querySelector('[data-km-pdp]');
      if(!meta) return;
      e.preventDefault();
      try { meta.scrollIntoView({ behavior:'smooth', block:'start' }); }
      catch(err){ meta.scrollIntoView(); }
    });
  }

  document.addEventListener('DOMContentLoaded', function(){ init(document); });
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
